<template>
  <div class="d-flex">
    <div
      class="d-flex flex-column px-2 border-right"
      style="width: 168px">
      <!-- <div
        class="radio-button "
        :class="infoTab === 'list' && 'radio-button-active'"
        @click="infoTab = 'list'">
        <span>Danh sách thẻ</span>
      </div> -->
      <div
        class="radio-button mt-2"
        :class="infoTab === 'history' && 'radio-button-active'"
        @click="infoTab = 'history'">
        <span>Lịch sử thao tác</span>
      </div>
    </div>

    <div class="pt-2">
      <div class="d-flex px-12 mt-1">
        <el-select
          class="me-1"
          @change="changeAction"
          v-model="action"
          filterable
          default-first-option
          placeholder="Chọn thao tác"
          size="small"
          style="max-width: 160px">
          <el-option
            label="Tất cả thao tác"
            value="all"></el-option>
          <el-option
            label="Gắn tag"
            value="tag"></el-option>
          <el-option
            label="Bỏ tag"
            value="untag"></el-option>
        </el-select>
        <el-input
          size="small"
          ref="inputMesage"
          @input="searchKeyChanged"
          v-model="searchKey"
          placeholder="Tìm kiếm tên,tài khoản ..."
          style="width: 300px"></el-input>
      </div>

      <el-table
        :header-row-style="{ 'font-size': '12px !important', color: '#373C41' }"
        :data="tagView"
        height="60vh"
        stripe
        size="mini"
        style="width: 100%; --bs-table-hover-color: white">
        <el-table-column
          label="Tên thẻ"
          width="200">
          <template slot-scope="scope">
            <div
              style="white-space: pre-line"
              class="text-normal">
              <div
                class=""
                style="margin-bottom: -6px">
                <tag-v2
                  :data="scope.row"
                  :inactive="true" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Thời gian"
          align="center"
          width="160">
          <template slot-scope="scope">
            <div
              style="white-space: pre-line"
              class="text-normal">
              {{ formatDateTimeShort(scope.row.ts) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Thao tác"
          align="center"
          width="130">
          <template slot-scope="scope">
            <div
              style="white-space: pre-line"
              class="text-normal">
              {{ scope.row.type == "untag" ? "Bỏ tag" : "Gắn tag" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Tài khoản"
          align="center">
          <template slot-scope="scope">
            <div
              style="white-space: pre-line"
              class="text-normal">
              {{ scope.row.username }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import TagV2 from "../TagV2.vue";

export default {
  name: "TagHistoryPopup",
  components: { TagV2 },
  props: ["conversationId"],
  data() {
    return {
      infoTab: "history",
      tags: [],
      tagView: [],
      searchKey: "",
      action: "all",
    };
  },
  methods: {
    searchKeyChanged() {
      this.showTags();
    },
    changeAction() {
      this.showTags();
    },
    showTags() {
      if (this.searchKey.length > 0) {
        this.tagView = this.tags.filter(
          (t) => t.name.toLowerCase().includes(this.searchKey.toLowerCase()) || t.username.toLowerCase().includes(this.searchKey.toLowerCase())
        );
      } else {
        this.tagView = this.tags;
      }

      if (this.action !== "all") {
        this.tagView = this.tagView.filter((t) => t.type === this.action);
      }
    },
    getHistory() {
      this.tags = [];
      this.$http.get("/api/tag/history", { params: { conversationId: this.conversationId } }).then((res) => {
        res.data.data.forEach((t) => {
          let search = this.app.tags.filter((s) => s.id == t.tagId);
          if (search != null && search.length > 0) {
            this.tags.push({
              username: t.username.split("/").length > 1 ? t.username.split("/")[1] : t.username,
              type: t.type,
              ts: t.ts,
              name: search[0].name + (search[0].assign ? " (*)" : ""),
              id: t.tagId,
              color: search[0].color,
            });
          }
        });
        this.tags.sort((a, b) => b.ts - a.ts);
        this.showTags();
      });
    },
  },
  created() {
    this.getHistory();
  },
};
</script>

<style scoped>
</style>